import { Prompt, useLocation } from 'react-router-dom';

import { useBeforeProfileMounted, useI18n, useSettings } from '../hooks';

const BeforePageChangePrompt: React.FC = () => {
	const location = useLocation();

	const p = useI18n(i18n => i18n.p);

	const { showPurchaseButton } = useSettings();
	const [beforeProfileMounted] = useBeforeProfileMounted();

	if (
		location.pathname.split('/')[2] !== 'purchase' ||
		process.env.NODE_ENV === 'development' ||
		beforeProfileMounted ||
		showPurchaseButton === false
	) return null;
	return <Prompt message={p.confirmLeave} />;
}

export default BeforePageChangePrompt